/* eslint-disable */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/scss/application.scss"
import "@appnest/masonry-layout"

import React from "react"
import GlobalContextProvider from "./src/context/GlobalContextProvider"
import { scrollToTop } from "./src/utils"

export const wrapRootElement = ({ element }) => {
  return <GlobalContextProvider>{element}</GlobalContextProvider>
}

export const shouldUpdateScroll = () => false

const queueScrollReset = () => {
  if (typeof window === "undefined") return
  window.requestAnimationFrame(() => {
    scrollToTop("smooth")
  })
}

export const onPreRouteUpdate = () => {
  queueScrollReset()
}

export const onRouteUpdate = () => {
  queueScrollReset()
}

export const onInitialClientRender = () => {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }
  scrollToTop("auto")
}
